export default class {
  constructor(targetElement) {
    this.target = targetElement
    this.slides = [...this.target.querySelectorAll('.slide')]
    this.index = 0
    this.activeClass = 'is-active'
    this.beforeClass = 'is-before'
    this.beforeSlide = null
    this.intervalId = null
    this.speed = 6000
  }

  init() {
    this.next(0)
  }

  next(index) {
    const _nextIndex = this.index + 1
    let nextIndex = _nextIndex < this.slides.length ? _nextIndex : 0
    if (!isNaN(index)) {
      nextIndex = index
    }
    this.index = nextIndex

    this.slides.forEach(slide => {
      slide.classList.remove(this.activeClass)
      slide.classList.remove(this.beforeClass)
    })

    if (this.beforeSlide) this.beforeSlide.classList.add(this.beforeClass)
    this.slides[nextIndex].classList.add(this.activeClass)

    this.beforeSlide = this.slides[nextIndex]
  }

  play() {
    this.intervalId = setInterval(this.next.bind(this), this.speed);
  }
}
